import BigNumber from 'bignumber.js';
import { Address, encodeFunctionData, WalletClient } from 'viem';

import stakingPoolAbi from 'modules/api/abi/DelegateStakingPool';
import { convertToWei } from 'modules/api/utils';
import { asAddress } from 'modules/api/utils/asAddress';
import { getChain } from 'modules/api/utils/getChain';

export async function delegate(
  walletClient: WalletClient,
  data: {
    poolAddress: Address;
    amount: BigNumber;
  },
): Promise<Address> {
  const { poolAddress, amount } = data;

  const encodedData = encodeFunctionData({
    abi: stakingPoolAbi,
    functionName: 'stake',
    args: [convertToWei(amount)],
  });

  const txHash = await walletClient.sendTransaction({
    to: poolAddress,
    data: encodedData,
    chain: getChain(),
    account: asAddress(walletClient.account?.address),
  });

  return txHash;
}
